import * as React from 'react';
import { connect } from 'react-redux';
import * as Components from '../../components/index';
import * as Models from '../../models/index';

import MessageList from './views/message.list';
import MessageDetails from './views/message.details';

import './index.scss';

interface StateProps {
	messages: Models.CorporateMessage[];
}
interface OwnState {
	cursor: number;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	messages: state.messages.messages,
});

export default connect(mapStateToProps)(
	class LoginIndex extends React.Component<StateProps, OwnState> {
		intervalId: any;
		constructor(props: StateProps) {
			super(props);
			this.state = {
				cursor: 0,
			};
		}
		componentDidMount() {
			this.intervalId = this.startChanger();
		}
		componentWillUnmount() {
			this.stopChanger();
		}
		startChanger() {
			return setInterval(() => {
				this.setState((prevState: OwnState): OwnState => {
					var nextCursor = prevState.cursor + 1;
					if (nextCursor >= this.props.messages.length) return { cursor: 0 };

					return { cursor: nextCursor };
				});
			}, 5000);
		}
		stopChanger() {
			clearInterval(this.intervalId);
		}
		render() {
			var message = this.props.messages[this.state.cursor];
			return (
				<Components.LayoutBlock className='messages-view' fill>
					<MessageList messages={this.props.messages} selected={message} onSelect={() => null} />
					{message ? <MessageDetails message={this.props.messages[this.state.cursor]} /> : null}
				</Components.LayoutBlock>
			);
		}
	}
);
